module.exports = __webpack_public_path__ + "videos/4.ada6830.mp4";